// extracted by mini-css-extract-plugin
export default {"noDataFound":"NoDataFound_noDataFound__YEhWY","content":"NoDataFound_content__aI7uO"};